// extracted by mini-css-extract-plugin
export default {"catalog":"AGeKA","list":"QN9JV","item":"uy82l"};